import React from "react";
import { motion } from "framer-motion";
import {
  Activity,
  ShieldCheck,
  Cable,
  Workflow,
  Layers,
  LayoutDashboard,
} from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import SectionBadge from "@/components/SectionBadge";

const icons = [Activity, ShieldCheck, Cable, Workflow, Layers, LayoutDashboard];

const DifferentiatorsSection = () => {
  const { t } = useLang();
  return (
    <section
      id="diferenciais"
      data-testid="differentiators-section"
      className="relative py-24 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionBadge>{t.differentiators.eyebrow}</SectionBadge>
          <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08] tracking-tight text-white text-balance">
            {t.differentiators.title}
          </h2>
          <p className="mt-4 text-[#b8c0cc] leading-relaxed">
            {t.differentiators.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {t.differentiators.items.map((d, i) => {
            const Icon = icons[i % icons.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="card-glow rounded-2xl bg-white/[0.02] border border-[#1dc7e9]/20 p-5 hover:border-[#1dc7e9]/55 hover:bg-white/[0.04] hover:-translate-y-0.5 transition-all duration-300 relative overflow-hidden flex flex-col"
                data-testid={`differentiator-card-${i}`}
              >
                <div className="w-11 h-11 rounded-xl border border-[#1dc7e9]/40 bg-[#1dc7e9]/5 flex items-center justify-center text-[#1dc7e9] mb-4 group-hover:shadow-[0_0_18px_rgba(29,199,233,0.4)]">
                  <Icon size={18} strokeWidth={1.7} />
                </div>
                <h3 className="text-white font-bold text-[14.5px] leading-snug tracking-tight">
                  {d.title}
                </h3>
                <p className="text-[#b8c0cc] text-[12.5px] mt-2 leading-relaxed">
                  {d.desc}
                </p>
                <div
                  aria-hidden
                  className="absolute -bottom-12 -right-12 w-32 h-32 glow-radial opacity-30 pointer-events-none"
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
